import React, { Component } from 'react';
import { Layout, BackTop, Icon, Popover, Avatar, Badge, message, Modal, Alert } from 'antd';
import { Form, Input, Button } from 'antd';
import { Container, Row, Col, NavbarBrand } from 'reactstrap';
import { Route } from 'react-router';
import { NavMenu } from './components/NavMenu';
import { Image } from './util/Image';
import { Link, Redirect, Switch, withRouter } from 'react-router-dom';
import { CreateHr } from './Hr/CreateHr';
import { HomeList } from './Home/HomeIndexGET';
import { HrList } from './Hr/HrIndexGET';
import { CreateWizard } from './Wizard/CreateWizard';
import SERVER_URL from './Global';
import { EditWizard } from './EditWizard/EditWizard';
import { ModifyHr } from './Modify/ModifyHr';
import { ModifyCat } from './Modify/ModifyCat';
import { CompanyCategoryList } from './CompanyCategory/CompanyCategoryIndexGET';
import { CreateCompanyCategory } from './CompanyCategory/CreateCompanyCategory';
import { GeoList } from './GeoRegion/GeoRegionIndex';
import { CreateGeo } from './GeoRegion/CreateGeo';
import { HandleUsers } from './Users/HandleUsers';
import { RestoreUsers } from './Users/RestoreUsers';
import Credits from './util/Credits';
import { FMKEditions } from './FileMaker/Editions/FMKEditions';
import { HandleEdition } from './FileMaker/Editions/HandleEdition';
import { FMKArticles } from './FileMaker/Articles/FMKArticles';
import { HandleArticles } from './FileMaker/Articles/HandleArticles';
import { DetailEdition } from './FileMaker/Editions/DetailEdition';
import { DetailArticle } from './FileMaker/Articles/DetailArticle';
import {MassiveImport} from "./FileMaker/Articles/MassiveImport";
import alertService from './Services/alertService';
import { canAccess, userRole } from './util/UserRole';

const { Header, Content, Sider } = Layout;

class Application extends Component {
    static displayName = Application.name;

    constructor(props) {
        super(props);

        let token = localStorage.getItem('notImportantStuff')
        let isRestore = false
        let isCredits = false
        if (window.location.pathname == "/users/restore") {
            isRestore = true
            token = null
        } else if (window.location.pathname == "/credits") {
            token = null
            isCredits = true
        }

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true,
            theme: 'dark',
            avatarColor: 'rgb(33, 58, 102)',
            showUserBadge: true,
            token: token,
            user: [],
            userRoleId: localStorage.getItem('roleId'),
            roleShortName: localStorage.getItem('roleShortName'),
            userName: localStorage.getItem('userName'),
            count: 0,
            language: "en",
            isLogged: true,
            isRestore: isRestore,
            isCredits: isCredits,
            passwordAccepted: true,
            showProfile: false,
            changingPassword: false,
            oldPassword: '',
            newPassword1: '',
            checkPassword: false,
            passwordCheckAlarm: false,
            passShort: false,
            loader: 0,
            error: null
        };

        this.handleLanguageChange = this.handleLanguageChange.bind(this);
        this.changeTheme = this.changeTheme.bind(this);        
        this.changeAvatarColor = this.changeAvatarColor.bind(this);
        this.newLogin = this.newLogin.bind(this);
        this.handleUsernameChange = this.handleUsernameChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleForm = this.handleForm.bind(this);
        this.logOut = this.logOut.bind(this);
        this.goToCredits = this.goToCredits.bind(this);
        this.showProfile = this.showProfile.bind(this);
        this.handleOldPassword = this.handleOldPassword.bind(this);
        this.handleNewPassword1 = this.handleNewPassword1.bind(this);
        this.handleNewPassword2 = this.handleNewPassword2.bind(this);
        this.updatePassword = this.updatePassword.bind(this);
        this.setLoader = this.setLoader.bind(this);
        this.setUserBadge = this.setUserBadge.bind(this);
    }


    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.updateUserBadge(this.props.location.pathname);
        }
    }

    updateUserBadge(location){
        switch (location) {
            case('/archive/articles'):
            case('/archive/'):
            case('/archive'):
            case('archive/edition/create'):
            case('/archive/edition/edit'):
            case('/archive/article/detail'):
            case('/archive/articles/edit'):
            case('/archive/articles/create'):
            case('/archive/articles/import'):
                this.setUserBadge(false)
                break;
            default:
                this.setUserBadge(true)
        }
    }

    componentDidMount() {
        alertService.subscribe(this.handleError);

        let user = JSON.parse(localStorage.getItem('user'));
        if (user == [] || user == null) {
            this.setState({ token: null, isLogged: false })
        } else {
            this.setState({ user: user })
        }

        if (this.state.language === null) {
            localStorage.setItem('lang', "en");
        }

        if (this.state.token === '') {
            localStorage.setItem('notImportantStuff', null);
            localStorage.setItem('roleShortName', null);
            localStorage.setItem('roleId', null);
        }

        fetch(
            `${SERVER_URL + 'api/APICheck/APICheckAuth'}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${this.state.token}`,
                'Content-Type': 'application/json'
            }
        }
        ).then(response => {
            if (response.status === 401) {
                localStorage.setItem('notImportantStuff', null);
                localStorage.setItem('roleShortName', null);
                this.setState({ token: null, isLogged: false })
            }
            else {
                this.setState({ isLogged: true })
            }
        })
    }

    componentWillUnmount() {
        alertService.unsubscribe(this.handleError);
    }

    handleError = (error) => {
        this.setState({ error });
    };

    handleUsernameChange(event) {
        this.setState({ username: event.target.value });
    }

    handlePasswordChange(event) {
        this.setState({ password: event.target.value });
    }

    handleForm(event) {
        this.newLogin(this.state.username, this.state.password);

        event.preventDefault();
    }
    
    changeTheme(value) {
        this.setState({
            theme: value ? 'dark' : 'light',
        });
    }

    showProfile() {
        this.setState({ showProfile: true })
    }

    changeAvatarColor() {
        var randCol = '#' + (0x1000000 + (Math.random()) * 0xffffff).toString(16).substr(1, 6);
        this.setState({ avatarColor: randCol })
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    logOut() {
        localStorage.setItem('notImportantStuff', null);
        localStorage.setItem('userName', null);
        localStorage.setItem('roleShortName', null);
        localStorage.setItem('user', null);
        localStorage.removeItem('roleId');
        document.title = "Polar - Login"
        this.setState({ token: null, userName: null })
    }

    newLogin(username, password) {
        return (
            fetch(
                `${SERVER_URL + "api/users/authenticate"}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        'username': `${username}`,
                        'password': `${password}`
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    if (!res.message) {
                        this.setState({ passwordAccepted: true, token: res.token, userName: res.firstName, roleShortName: res.privileges.userRole.name })
                        localStorage.setItem('notImportantStuff', res.token);
                        localStorage.setItem('userName', res.firstName);
                        localStorage.setItem('roleShortName', res.privileges.userRole.name);

                        fetch(
                            `${SERVER_URL + "api/users/" + res.id}`, {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${res.token}`
                            }
                        }
                        ).then(response => response.json())
                            .then(res => {
                                localStorage.setItem('roleId', res.data.userRoleId);
                                this.setState({ user: res.data, userRoleId: res.data.userRoleId})
                                
                                localStorage.setItem('user', JSON.stringify(res.data));
                            })
                        
                    }
                    else {
                        this.setState({ passwordAccepted: false})
                    }
                })
        );
    }

    handleLanguageChange(e) {
        e.preventDefault();
        let lang = e.target.value;
        this.setState(prevState => ({
            language: lang
        }))

        localStorage.setItem('lang', lang);
    }

    goToCredits() {
        window.location = "/credits";
    }

    handleOldPassword(event) {
        this.setState({ oldPassword: event.target.value })          
    }

    handleNewPassword1(event) {
        this.setState({ newPassword1: event.target.value, passShort: false })

        if (event.target.value.length < 5 && event.target.value.length > 0) {
            this.setState({ newPassword1: null, passShort: true })
        } else if (event.target.value.length === 0) {
            this.setState({ newPassword1: null, passShort: false })
        }
    }

    handleNewPassword2(event) {
        if (event.target.value.length === 0) {
            this.setState({ checkPassword: false, passwordCheckAlarm: false })
        } else {
            if (this.state.newPassword1 == event.target.value) {
                this.setState({ checkPassword: true, passwordCheckAlarm: false })
            } else {
                this.setState({ checkPassword: false, passwordCheckAlarm: true })
            }
        }
    }

    updatePassword() {
        if (this.state.checkPassword) {
            fetch(`${SERVER_URL + 'api/users'}`, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.token}`,
                },
                body: JSON.stringify({
                    'FirstName': this.state.user.firstName,
                    'LastName': this.state.user.lastName,
                    'Username': this.state.user.username,
                    'Email': this.state.user.email,
                    'oldpassword': this.state.oldPassword,
                    'password': this.state.newPassword1,
                    'IsEnabled': true,
                    'UserRoleId': this.state.userRoleId,
                    'userID': this.state.user.userId
                })
            }).then(response => response.json())
                .then(res => {
                    if (res.ok) {
                        message.success('Password successfully changed');
                        this.setState({ showProfile: false, changingPassword: false })
                    } else {
                        message.warning('Current Password is wrong');
                    }
                })
        }
    }

    setLoader(value) {
        if (value) {
            this.setState((prevState) => ({
                loader: prevState.loader + 1
            }));
        }
        else {
            this.setState((prevState) => ({
                loader: prevState.loader - 1
            }));
        }
    }

    setUserBadge(value) {
        this.setState({showUserBadge: value});
    }

    render() {
        let loader =
            <div className="loader">
                <div className="dotContainer">
                    <div className="dots"></div>
                </div>
                <p> Loading...</p>
            </div>

        let content =
            <div style={{ maxWidth: '600px' }}>
                {/*<Link tag="reputation manager" className="text-dark" to="/users/list" >
                    <Icon type="solution" /> Users List
                </Link>*/}
                <p onClick={this.showProfile}><Icon type="user" /> Account</p>
                <hr style={{ marginTop: 10, marginBottom: 10 }} />
                <Link tag="reputation manager" className="text-dark" to="/" onClick={this.logOut} >
                    <Icon type="logout" /> Logout
                </Link>
                              

                {/*<div>
                    Change Language: <select onChange={this.handleLanguageChange}>
                        <option value="en">En- English</option>
                        <option value="it">It- Italian</option>
                    </select>
                </div>*/}
            </div>

        let content2 = <p>Reputation Manager S.p.a.</p>

        let username = this.state.userName !== '' ? "Username" : "Username"

        let passwordError = this.state.passwordAccepted ? '' :
            <div className="hiddenError">
                Username o password errati
            </div>

        let creditsOrNot = this.state.isRestore || this.state.isCredits ?
            <Switch>
                <Route exact path='/users/restore' render={(props) => <RestoreUsers {...props} />} />
                <Route exact path='/credits' render={(props) => <Credits {...props} token={this.state.token} />} />
            </Switch> :
            <Form onSubmit={this.handleForm} className="login-form">
                <Image src={require('./logo_polar.png')} class="logoLogin" />

                <Form.Item>
                    <Input autoComplete="new-password"
                        prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                        placeholder={username}
                        onChange={this.handleUsernameChange}
                    />
                </Form.Item>

                <Form.Item>
                    <Input.Password
                        prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                        autoComplete="new-password"
                        placeholder="Password"
                        onChange={this.handlePasswordChange}
                    />
                </Form.Item>

                <Form.Item>

                    <Button type="primary" htmlType="submit" className="login-form-button">
                        Log in
                    </Button>

                    {passwordError}

                </Form.Item>

                <div style={{display:'flex'}}>
                    <span onClick={this.goToCredits} className="fakeLink polarBlue">Credits</span>
                    <div style={{ display: 'block', width: '100%' }}>
                        <Link tag="reputation manager" style={{ display: 'block', width: '100%', textAlign: 'right' }} target="_blank" to="https://www.reputation-manager.it/" ><span className="fakeLink polarBlue">powered by Reputation Manager</span></Link>
                    </div>
                </div>

            </Form >

        let roleShortName = this.state.roleShortName !== '' || this.state.roleShortName !== null ? "(" + this.state.roleShortName + ")" : ''

        let passMatch = this.state.passwordCheckAlarm ? <p className="errorPasswordMatch">New Password and Confirm Password don't match</p> : null

        let passShort = this.state.passShort ? <p className="errorPasswordMatch">New Password must be at least 5 characters long</p> : null

        let inputPassword = this.state.changingPassword ?
            <div className="changepass">
                <h4>Change Password</h4>
                <div>
                    <Input.Password autoComplete="new-password" placeholder="Current Password" style={{ width: '48%', marginRight: '2%' }} onChange={this.handleOldPassword} />    
                </div>
                <div style={{ display: 'inline-flex', width:'100%', marginTop:'20px' }}>
                    <Input.Password autoComplete="new-password" placeholder="New Password" style={{ width: '48%', marginRight: '2%' }} onChange={this.handleNewPassword1} />
                    <Input.Password autoComplete="new-password" placeholder="Confirm Password" style={{ width: '48%', marginLeft: '2%' }} onChange={this.handleNewPassword2} />
                </div>
                {passMatch}
                {passShort}
            </div> : ''


        let footerChangePass = !this.state.changingPassword ?
            <Button type="primary" key="back" onClick={() => this.setState({ changingPassword: true })}>
                Change Password
            </Button> : !this.state.checkPassword ?
                <Popover content="New Password and Confirm Password must match and must be at least 5 characters long">
                    <Button type="primary" key="back" onClick={this.updatePassword} disabled>
                        Save new password
                    </Button>
                </Popover>
                :
                <Button type="primary" key="back" onClick={this.updatePassword}>
                        Save new password
                </Button>  

        let createDate = this.state.user.created ? this.state.user.created.slice(8, 10) + "/" + this.state.user.created.slice(5, 7) + "/" + this.state.user.created.slice(0, 4) + " (" + this.state.user.created.slice(11, 16) + ")" : null


        const home_path = this.state.userRoleId == userRole.Archivio_Riviste_User ? '/archive' : '/'
        let loggedOrNot = this.state.token != null && this.state.userRoleId  ?
            <Layout style={{ minHeight: '100vh' }}>
                <Sider width={160} theme={this.state.theme} trigger={null} collapsible collapsed={this.state.collapsed}>
                    <NavbarBrand tag={Link} to="/">
                        <Image src={require('./logo_polar_white.png')} class="logoHead" />
                        <Image src={require('./logo_polar_white_collapsed.png')} class="logoHeadCollapsed" />
                        <p className="textCollapsed">Polar</p>
                    </NavbarBrand>
                    
                    <NavMenu redirectHome={this.redirectHome} isLogged={this.state.isLogged} theme={this.state.theme} userRoleId={this.state.userRoleId} />
                    <div className="fondoMenu">
                        <Container fluid={true}>
                            <Row >
                                {/*<Col className="systemOptions" sm='6'>
                                    <Switch
                                        checked={this.state.theme === 'dark'}
                                        onChange={this.changeTheme}
                                        checkedChildren="Dark"
                                        unCheckedChildren="Light"
                                    />
                                </Col>*/}

                                <Col className="triggerMenu" sm='12'>
                                    <div className="bloccoTrigger">
                                        {<Icon
                                            className="trigger"
                                            type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                                            onClick={this.toggleNavbar}
                                        />}
                                    </div>
                                    
                                    <div className="logoReputationContainer">
                                        <Link tag="reputation manager" style={{ display: 'block', width: '100%', textAlign: 'right' }} target="_blank" to="https://www.reputation-manager.it/" >
                                            <Image src={require('./logo_RM_negativo.png')} class="logoSmall" />
                                            <Image src={require('./logo_RM_negativo.png')} class="logoLarge" />
                                        </Link>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </Sider>
                <Layout>
                    <Header className="headerStyle">
                        <Container fluid={true}>
                            <Row className="overContent">

                                {this.state.showUserBadge && (
                                    <Badge className="loginnedAvatar" count={this.state.count}>
                                        <Popover placement="bottomRight" content={content} trigger="click">
                                            <div style={{ cursor: 'pointer' }}>
                                                <p className="userNameStyle"><b>{this.state.user.username}</b> <Avatar style={{ backgroundColor: this.state.avatarColor, marginLeft:'5px' }} icon="user" /></p>
                                            </div>
                                        </Popover>
                                    </Badge>
                                )}

                            </Row>
                        </Container>
                    </Header>
                    <Content style={{ margin: '-5px 0px 0px 15px' }}>
                        <BackTop />
                        <Switch>
                            {/* SOLO ADMIN */}
                            {canAccess([userRole.Admin], this.state.userRoleId) && (
                               <Route exact path='/users/list' render={(props) => <HandleUsers {...props} token={this.state.token} />} />
                            )}
                            {canAccess([userRole.Admin], this.state.userRoleId) && (
                               <Route exact path='/category/index' render={(props) => <CompanyCategoryList {...props} token={this.state.token} />} />
                            )}
                            

                            {/* UOMINI e COMUNICAZIONI */}
                            {canAccess([userRole.Admin, userRole.U_C_User], this.state.userRoleId) && (
                                <Route exact path='/' render={(props) => <HomeList {...props} token={this.state.token} collapsed={this.state.collapsed} lang={this.state.language} />}/>
                            )}
                            {canAccess([userRole.Admin, userRole.U_C_User], this.state.userRoleId) && (
                                <Route exact path='/create' render={(props) => <CreateWizard {...props} token={this.state.token}/>} />
                            )}
                            {canAccess([userRole.Admin, userRole.U_C_User], this.state.userRoleId) && (
                                <Route exact path='/credits' render={(props) => <Credits {...props} token={this.state.token} />} />
                            )}
                            {canAccess([userRole.Admin, userRole.U_C_User], this.state.userRoleId) && (
                                <Route exact path='/edit' render={(props) => <EditWizard {...props} token={this.state.token} />} />
                            )}
                            {canAccess([userRole.Admin, userRole.U_C_User], this.state.userRoleId) && (
                                <Route exact path='/modifyhr' render={(props) => <ModifyHr {...props} token={this.state.token} />} />
                            )}
                            {canAccess([userRole.Admin, userRole.U_C_User], this.state.userRoleId) && (
                                <Route exact path='/places/create' render={(props) => <CreateGeo {...props} isEdit={false} token={this.state.token} />} />
                            )}
                            {canAccess([userRole.Admin, userRole.U_C_User], this.state.userRoleId) && (
                                <Route exact path='/places/edit' render={(props) => <CreateGeo {...props} isEdit={true} token={this.state.token} />} />
                            )}
                            {canAccess([userRole.Admin, userRole.U_C_User], this.state.userRoleId) && (
                                <Route exact path='/modifycat' render={(props) => <ModifyCat {...props} token={this.state.token} />} />
                            )}
                            {canAccess([userRole.Admin, userRole.U_C_User], this.state.userRoleId) && (
                                <Route exact path='/places/index' render={(props) => <GeoList {...props} token={this.state.token} />} />
                            )}
                            {canAccess([userRole.Admin, userRole.U_C_User], this.state.userRoleId) && (
                                <Route exact path='/hr/create' render={(props) => <CreateHr {...props} token={this.state.token} />} />
                            )}
                            {canAccess([userRole.Admin, userRole.U_C_User], this.state.userRoleId) && (
                               <Route exact path='/hr/index' render={(props) => <HrList {...props} token={this.state.token} />} />
                            )}
                            {canAccess([userRole.Admin, userRole.U_C_User], this.state.userRoleId) && (
                                <Route exact path='/category/create' render={(props) => <CreateCompanyCategory {...props} token={this.state.token} />} />
                            )}
                            
                           
                            {/* ARCHIVIO RIVISTE (file maker) */}
                            {canAccess([userRole.Admin, userRole.Archivio_Riviste_User], this.state.userRoleId) && (
                                <Route exact path='/archive' render={(props) =>
                                    <FMKEditions {...props} showUserBadge={this.setUserBadge} usercontent={content} avatarColor={this.state.avatarColor} loader={this.setLoader} token={this.state.token} />}
                                />
                            )}
                            {canAccess([userRole.Admin, userRole.Archivio_Riviste_User], this.state.userRoleId) && (
                                <Route exact path='/archive/edition/create' render={(props) =>
                                    <HandleEdition showUserBadge={this.setUserBadge} usercontent={content} avatarColor={this.state.avatarColor} loader={this.setLoader} {...props} token={this.state.token} />}
                                />
                            )}
                            {canAccess([userRole.Admin, userRole.Archivio_Riviste_User], this.state.userRoleId) && (
                                 <Route exact path='/archive/edition/edit' render={(props) =>
                                    <HandleEdition {...props} showUserBadge={this.setUserBadge} usercontent={content} avatarColor={this.state.avatarColor}  isEdit={true} loader={this.setLoader} token={this.state.token} />}
                                />
                            )}
                            {canAccess([userRole.Admin, userRole.Archivio_Riviste_User], this.state.userRoleId) && (
                                <Route exact path='/archive/edition/detail' render={(props) =>
                                    <DetailEdition {...props} showUserBadge={this.setUserBadge} usercontent={content} avatarColor={this.state.avatarColor} loader={this.setLoader} token={this.state.token} />}
                                />
                            )}
                            {canAccess([userRole.Admin, userRole.Archivio_Riviste_User], this.state.userRoleId) && (
                                <Route exact path='/archive/article/detail' render={(props) =>
                                    <DetailArticle {...props} showUserBadge={this.setUserBadge} usercontent={content} avatarColor={this.state.avatarColor} loader={this.setLoader} token={this.state.token} />}
                                />
                            )}
                            {canAccess([userRole.Admin, userRole.Archivio_Riviste_User], this.state.userRoleId) && (
                                <Route exact path='/archive/articles' render={(props) =>
                                    <FMKArticles {...props} showUserBadge={this.setUserBadge} usercontent={content} avatarColor={this.state.avatarColor} loader={this.setLoader} token={this.state.token} />}
                                />
                            )}
                            {canAccess([userRole.Admin, userRole.Archivio_Riviste_User], this.state.userRoleId) && (
                                <Route exact path="/archive/articles/edit" render={(props) =>
                                    <HandleArticles {...props} showUserBadge={this.setUserBadge} usercontent={content} avatarColor={this.state.avatarColor} loader={this.setLoader} token={this.state.token} />}
                                />
                            )}
                            {canAccess([userRole.Admin, userRole.Archivio_Riviste_User], this.state.userRoleId) && (
                                <Route exact path="/archive/articles/create" render={(props) =>
                                    <HandleArticles {...props} showUserBadge={this.setUserBadge} usercontent={content} avatarColor={this.state.avatarColor} loader={this.setLoader} token={this.state.token} />}
                                />
                            )}
                            {canAccess([userRole.Admin, userRole.Archivio_Riviste_User], this.state.userRoleId) && (
                                <Route exact path="/archive/articles/import" render={(props) =>
                                    <MassiveImport {...props} showUserBadge={this.setUserBadge} usercontent={content} avatarColor={this.state.avatarColor} loader={this.setLoader} token={this.state.token} />}
                                />
                            )}

                            <Redirect from='*' to={home_path} />
                        </Switch>
                        <Modal
                            title="User's profile:"
                            visible={this.state.showProfile}
                            footer={footerChangePass}
                            onCancel={() => this.setState({ showProfile: false })}>
                            <p style={{ width: '100%', textAlign: 'left' }}><b>Username:</b> {this.state.user.username}</p>
                            <p style={{ width: '100%', textAlign: 'left' }}><b>Role:</b> {this.state.roleShortName}</p>
                            <p style={{ width: '100%', textAlign: 'left' }}><b>Name:</b> {this.state.user.firstName}</p>
                            <p style={{ width: '100%', textAlign: 'left' }}><b>Surname:</b> {this.state.user.lastName}</p>
                            <p style={{ width: '100%', textAlign: 'left' }}><b>Email:</b> {this.state.user.email}</p>
                            <p style={{ width: '100%', textAlign: 'left' }}><b>Date of creation:</b> {createDate}</p>

                            {inputPassword}
                            </Modal>
                        {alertService.show &&
                            <Alert style={{position:'fixed', bottom: 20, right: 20}} message={alertService.title} description={alertService.message} type={alertService.type} showIcon />
                        }
                    </Content>
                </Layout>
                {
                    this.state.loader != 0  && loader
                }
            </Layout>
            : 
            <div className="containerLogged">
                <div className="login-bg">
                    <div className="container">
                        <div style={{height: '100vh'}} className="row justify-content-center">
                            { creditsOrNot }
                        </div>
                    </div>
                </div>
            </div>

        return (
            <div>
                {loggedOrNot}
            </div>
    );
  }
}

const App = withRouter(Application);
export default App;



// WEBPACK FOOTER //
// ./src/App.js